import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { UserIcon, MailIcon, LockIcon, PhoneIcon, CheckIcon, EyeIcon, EyeOffIcon, FacebookIcon, ArrowRightIcon, CalendarIcon, TicketIcon, BriefcaseIcon, UsersIcon, BuildingIcon, ShieldIcon, CreditCardIcon, BarChartIcon } from 'lucide-react';
const Register = () => {
  const [formType, setFormType] = useState('signup'); // 'signup' or 'login'
  const [showPassword, setShowPassword] = useState(false);
  const [accountType, setAccountType] = useState('personal'); // 'personal' or 'business'
  const [showAccountDetails, setShowAccountDetails] = useState(false);
  const toggleFormType = () => {
    setFormType(formType === 'signup' ? 'login' : 'signup');
  };
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const handleAccountTypeChange = (type: string) => {
    setAccountType(type);
    setShowAccountDetails(true);
  };
  const closeAccountDetails = () => {
    setShowAccountDetails(false);
  };
  return <div className="pb-16" data-id="element-2966">
      <div className="border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800" data-id="element-2967">
        <div className="max-w-4xl mx-auto p-4" data-id="element-2968">
          <h1 className="text-2xl font-bold mb-2 flex items-center dark:text-gray-200" data-id="element-2969">
            <UserIcon className="w-6 h-6 mr-2" data-id="element-2970" />
            {formType === 'signup' ? 'Create Account' : 'Sign In'}
          </h1>
          <p className="text-sm text-gray-600 dark:text-gray-300 mb-4" data-id="element-2971">
            {formType === 'signup' ? 'Join the JoinToday community and connect with like-minded people' : 'Welcome back! Sign in to your JoinToday account'}
          </p>
        </div>
      </div>
      <div className="max-w-md mx-auto p-4" data-id="element-2972">
        <div className="border border-gray-300 dark:border-gray-600 rounded-lg overflow-hidden mb-6" data-id="element-2973">
          {/* Form Type Toggle */}
          <div className="grid grid-cols-2 border-b border-gray-200 dark:border-gray-700" data-id="element-2974">
            <button className={`py-3 text-center ${formType === 'signup' ? 'bg-gray-100 dark:bg-gray-700 font-medium dark:text-gray-200' : 'bg-white dark:bg-gray-800 dark:text-gray-300'}`} onClick={() => setFormType('signup')} data-id="element-2975">
              Sign Up
            </button>
            <button className={`py-3 text-center ${formType === 'login' ? 'bg-gray-100 dark:bg-gray-700 font-medium dark:text-gray-200' : 'bg-white dark:bg-gray-800 dark:text-gray-300'}`} onClick={() => setFormType('login')} data-id="element-2976">
              Sign In
            </button>
          </div>
          {/* Social Login */}
          <div className="p-6" data-id="element-2977">
            <div className="space-y-3 mb-6" data-id="element-2978">
              <button className="w-full flex items-center justify-center py-2 px-4 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 dark:text-gray-200" data-id="element-2979">
                <div className="w-5 h-5 mr-2" data-id="element-2980" />
                <span data-id="element-2981">
                  {formType === 'signup' ? 'Sign up' : 'Sign in'} with Google
                </span>
              </button>
              <button className="w-full flex items-center justify-center py-2 px-4 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 dark:text-gray-200" data-id="element-2982">
                <FacebookIcon className="w-5 h-5 mr-2" data-id="element-2983" />
                <span data-id="element-2984">
                  {formType === 'signup' ? 'Sign up' : 'Sign in'} with Facebook
                </span>
              </button>
            </div>
            <div className="flex items-center my-4" data-id="element-2985">
              <div className="flex-grow border-t border-gray-200 dark:border-gray-700" data-id="element-2986"></div>
              <span className="mx-4 text-sm text-gray-500 dark:text-gray-400" data-id="element-2987">
                OR
              </span>
              <div className="flex-grow border-t border-gray-200 dark:border-gray-700" data-id="element-2988"></div>
            </div>
            {/* Account Type Selection - Only for Sign Up */}
            {formType === 'signup' && <div className="mb-4" data-id="element-2989">
                <label className="block text-sm font-medium mb-2 dark:text-gray-200" data-id="element-2990">
                  Account Type
                </label>
                <div className="grid grid-cols-2 gap-3" data-id="element-2991">
                  <button type="button" className={`py-2 px-4 border rounded-md flex items-center justify-center ${accountType === 'personal' ? 'border-gray-800 dark:border-gray-200 bg-gray-100 dark:bg-gray-700 dark:text-gray-200' : 'border-gray-300 dark:border-gray-600 dark:text-gray-300'}`} onClick={() => handleAccountTypeChange('personal')} data-id="element-2992">
                    <UserIcon className="w-4 h-4 mr-2" data-id="element-2993" />
                    <span data-id="element-2994">Personal</span>
                  </button>
                  <button type="button" className={`py-2 px-4 border rounded-md flex items-center justify-center ${accountType === 'business' ? 'border-gray-800 dark:border-gray-200 bg-gray-100 dark:bg-gray-700 dark:text-gray-200' : 'border-gray-300 dark:border-gray-600 dark:text-gray-300'}`} onClick={() => handleAccountTypeChange('business')} data-id="element-2995">
                    <BuildingIcon className="w-4 h-4 mr-2" data-id="element-2996" />
                    <span data-id="element-2997">Business</span>
                  </button>
                </div>
                {/* Account Type Details */}
                {showAccountDetails && <div className="mt-4 p-4 border border-gray-200 dark:border-gray-700 rounded-lg bg-gray-50 dark:bg-gray-800 relative" data-id="element-2998">
                    <button onClick={closeAccountDetails} className="absolute top-2 right-2 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300" data-id="element-2999">
                      <span className="sr-only" data-id="element-3000">Close</span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-3001">
                        <line x1="18" y1="6" x2="6" y2="18" data-id="element-3002"></line>
                        <line x1="6" y1="6" x2="18" y2="18" data-id="element-3003"></line>
                      </svg>
                    </button>
                    <h3 className="text-md font-medium mb-3 dark:text-gray-200" data-id="element-3004">
                      {accountType === 'personal' ? 'Personal Account' : 'Business Account'}{' '}
                      Features
                    </h3>
                    {accountType === 'personal' ? <div className="space-y-2" data-id="element-3005">
                        <div className="flex items-start" data-id="element-3006">
                          <div className="flex-shrink-0 mt-0.5" data-id="element-3007">
                            <CheckIcon className="h-4 w-4 text-gray-600 dark:text-gray-300" data-id="element-3008" />
                          </div>
                          <div className="ml-2" data-id="element-3009">
                            <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-3010">
                              <span className="font-medium dark:text-gray-200" data-id="element-3011">
                                Join Communities:
                              </span>{' '}
                              Connect with like-minded individuals and groups
                            </p>
                          </div>
                        </div>
                        <div className="flex items-start" data-id="element-3012">
                          <div className="flex-shrink-0 mt-0.5" data-id="element-3013">
                            <CheckIcon className="h-4 w-4 text-gray-600 dark:text-gray-300" data-id="element-3014" />
                          </div>
                          <div className="ml-2" data-id="element-3015">
                            <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-3016">
                              <span className="font-medium dark:text-gray-200" data-id="element-3017">
                                Attend Events:
                              </span>{' '}
                              Discover and book tickets to local events
                            </p>
                          </div>
                        </div>
                        <div className="flex items-start" data-id="element-3018">
                          <div className="flex-shrink-0 mt-0.5" data-id="element-3019">
                            <CheckIcon className="h-4 w-4 text-gray-600 dark:text-gray-300" data-id="element-3020" />
                          </div>
                          <div className="ml-2" data-id="element-3021">
                            <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-3022">
                              <span className="font-medium dark:text-gray-200" data-id="element-3023">
                                Save Content:
                              </span>{' '}
                              Bookmark events, jobs, and community posts
                            </p>
                          </div>
                        </div>
                        <div className="flex items-start" data-id="element-3024">
                          <div className="flex-shrink-0 mt-0.5" data-id="element-3025">
                            <CheckIcon className="h-4 w-4 text-gray-600 dark:text-gray-300" data-id="element-3026" />
                          </div>
                          <div className="ml-2" data-id="element-3027">
                            <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-3028">
                              <span className="font-medium dark:text-gray-200" data-id="element-3029">
                                Apply for Jobs:
                              </span>{' '}
                              Browse and apply to career opportunities
                            </p>
                          </div>
                        </div>
                        <div className="flex items-start" data-id="element-3030">
                          <div className="flex-shrink-0 mt-0.5" data-id="element-3031">
                            <CheckIcon className="h-4 w-4 text-gray-600 dark:text-gray-300" data-id="element-3032" />
                          </div>
                          <div className="ml-2" data-id="element-3033">
                            <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-3034">
                              <span className="font-medium dark:text-gray-200" data-id="element-3035">
                                Free Account:
                              </span>{' '}
                              No subscription fees for basic features
                            </p>
                          </div>
                        </div>
                      </div> : <div className="space-y-2" data-id="element-3036">
                        <div className="flex items-start" data-id="element-3037">
                          <div className="flex-shrink-0 mt-0.5" data-id="element-3038">
                            <CheckIcon className="h-4 w-4 text-gray-600 dark:text-gray-300" data-id="element-3039" />
                          </div>
                          <div className="ml-2" data-id="element-3040">
                            <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-3041">
                              <span className="font-medium dark:text-gray-200" data-id="element-3042">
                                Create Events:
                              </span>{' '}
                              Host and manage your own events with ticketing
                            </p>
                          </div>
                        </div>
                        <div className="flex items-start" data-id="element-3043">
                          <div className="flex-shrink-0 mt-0.5" data-id="element-3044">
                            <CheckIcon className="h-4 w-4 text-gray-600 dark:text-gray-300" data-id="element-3045" />
                          </div>
                          <div className="ml-2" data-id="element-3046">
                            <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-3047">
                              <span className="font-medium dark:text-gray-200" data-id="element-3048">
                                Business Profile:
                              </span>{' '}
                              Showcase your company, venue, or services
                            </p>
                          </div>
                        </div>
                        <div className="flex items-start" data-id="element-3049">
                          <div className="flex-shrink-0 mt-0.5" data-id="element-3050">
                            <CheckIcon className="h-4 w-4 text-gray-600 dark:text-gray-300" data-id="element-3051" />
                          </div>
                          <div className="ml-2" data-id="element-3052">
                            <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-3053">
                              <span className="font-medium dark:text-gray-200" data-id="element-3054">
                                Analytics Dashboard:
                              </span>{' '}
                              Track engagement, sales, and audience insights
                            </p>
                          </div>
                        </div>
                        <div className="flex items-start" data-id="element-3055">
                          <div className="flex-shrink-0 mt-0.5" data-id="element-3056">
                            <CheckIcon className="h-4 w-4 text-gray-600 dark:text-gray-300" data-id="element-3057" />
                          </div>
                          <div className="ml-2" data-id="element-3058">
                            <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-3059">
                              <span className="font-medium dark:text-gray-200" data-id="element-3060">
                                Post Jobs:
                              </span>{' '}
                              Advertise job openings and manage applications
                            </p>
                          </div>
                        </div>
                        <div className="flex items-start" data-id="element-3061">
                          <div className="flex-shrink-0 mt-0.5" data-id="element-3062">
                            <CheckIcon className="h-4 w-4 text-gray-600 dark:text-gray-300" data-id="element-3063" />
                          </div>
                          <div className="ml-2" data-id="element-3064">
                            <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-3065">
                              <span className="font-medium dark:text-gray-200" data-id="element-3066">
                                Payment Processing:
                              </span>{' '}
                              Secure ticket sales with multiple payment options
                            </p>
                          </div>
                        </div>
                        <div className="flex items-start" data-id="element-3067">
                          <div className="flex-shrink-0 mt-0.5" data-id="element-3068">
                            <CheckIcon className="h-4 w-4 text-gray-600 dark:text-gray-300" data-id="element-3069" />
                          </div>
                          <div className="ml-2" data-id="element-3070">
                            <p className="text-sm text-gray-600 dark:text-gray-300" data-id="element-3071">
                              <span className="font-medium dark:text-gray-200" data-id="element-3072">
                                Premium Support:
                              </span>{' '}
                              Priority customer service for business accounts
                            </p>
                          </div>
                        </div>
                      </div>}
                    <div className="mt-3 pt-3 border-t border-gray-200 dark:border-gray-700" data-id="element-3073">
                      <div className="flex items-center" data-id="element-3074">
                        <div className="w-6 h-6 bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center mr-2" data-id="element-3075">
                          <ShieldIcon className="w-3 h-3 text-gray-600 dark:text-gray-300" data-id="element-3076" />
                        </div>
                        <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-3077">
                          You can change your account type later in your profile
                          settings
                        </p>
                      </div>
                    </div>
                  </div>}
                <p className="text-xs text-gray-500 dark:text-gray-400 mt-1" data-id="element-3078">
                  {accountType === 'business' ? 'For event organizers, sellers, and service providers' : 'For individuals looking to join communities and attend events'}
                </p>
              </div>}
            {/* Form Fields */}
            <form className="space-y-4" data-id="element-3079">
              {formType === 'signup' && <div data-id="element-3080">
                  <label htmlFor="name" className="block text-sm font-medium mb-1 dark:text-gray-200" data-id="element-3081">
                    Full Name
                  </label>
                  <div className="relative" data-id="element-3082">
                    <input type="text" id="name" className="w-full p-2 pl-9 border border-gray-300 dark:border-gray-600 rounded-md dark:bg-gray-800 dark:text-gray-200" placeholder="Enter your full name" data-id="element-3083" />
                    <UserIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400 dark:text-gray-500" data-id="element-3084" />
                  </div>
                </div>}
              <div data-id="element-3085">
                <label htmlFor="email" className="block text-sm font-medium mb-1 dark:text-gray-200" data-id="element-3086">
                  Email Address
                </label>
                <div className="relative" data-id="element-3087">
                  <input type="email" id="email" className="w-full p-2 pl-9 border border-gray-300 dark:border-gray-600 rounded-md dark:bg-gray-800 dark:text-gray-200" placeholder="Enter your email" data-id="element-3088" />
                  <MailIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400 dark:text-gray-500" data-id="element-3089" />
                </div>
              </div>
              {formType === 'signup' && accountType === 'business' && <div data-id="element-3090">
                  <label htmlFor="business" className="block text-sm font-medium mb-1 dark:text-gray-200" data-id="element-3091">
                    Business Name
                  </label>
                  <div className="relative" data-id="element-3092">
                    <input type="text" id="business" className="w-full p-2 pl-9 border border-gray-300 dark:border-gray-600 rounded-md dark:bg-gray-800 dark:text-gray-200" placeholder="Enter your business name" data-id="element-3093" />
                    <BuildingIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400 dark:text-gray-500" data-id="element-3094" />
                  </div>
                </div>}
              {formType === 'signup' && <div data-id="element-3095">
                  <label htmlFor="phone" className="block text-sm font-medium mb-1 dark:text-gray-200" data-id="element-3096">
                    Phone Number
                  </label>
                  <div className="relative" data-id="element-3097">
                    <input type="tel" id="phone" className="w-full p-2 pl-9 border border-gray-300 dark:border-gray-600 rounded-md dark:bg-gray-800 dark:text-gray-200" placeholder="Enter your phone number" data-id="element-3098" />
                    <PhoneIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400 dark:text-gray-500" data-id="element-3099" />
                  </div>
                </div>}
              <div data-id="element-3100">
                <label htmlFor="password" className="block text-sm font-medium mb-1 dark:text-gray-200" data-id="element-3101">
                  Password
                </label>
                <div className="relative" data-id="element-3102">
                  <input type={showPassword ? 'text' : 'password'} id="password" className="w-full p-2 pl-9 pr-10 border border-gray-300 dark:border-gray-600 rounded-md dark:bg-gray-800 dark:text-gray-200" placeholder={formType === 'signup' ? 'Create a password' : 'Enter your password'} data-id="element-3103" />
                  <LockIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400 dark:text-gray-500" data-id="element-3104" />
                  <button type="button" onClick={togglePasswordVisibility} className="absolute right-3 top-1/2 transform -translate-y-1/2" data-id="element-3105">
                    {showPassword ? <EyeOffIcon className="w-4 h-4 text-gray-400 dark:text-gray-500" data-id="element-3106" /> : <EyeIcon className="w-4 h-4 text-gray-400 dark:text-gray-500" data-id="element-3107" />}
                  </button>
                </div>
              </div>
              {formType === 'signup' && <div className="flex items-start" data-id="element-3108">
                  <div className="flex items-center h-5" data-id="element-3109">
                    <input id="terms" type="checkbox" className="w-4 h-4 border border-gray-300 dark:border-gray-600 rounded" data-id="element-3110" />
                  </div>
                  <label htmlFor="terms" className="ml-2 text-xs text-gray-600 dark:text-gray-300" data-id="element-3111">
                    I agree to the{' '}
                    <Link to="/terms" className="underline" data-id="element-3112">
                      Terms of Service
                    </Link>{' '}
                    and{' '}
                    <Link to="/privacy" className="underline" data-id="element-3113">
                      Privacy Policy
                    </Link>
                  </label>
                </div>}
              <button type="submit" className="w-full bg-gray-800 text-white dark:bg-gray-200 dark:text-gray-800 py-2 rounded-md" data-id="element-3114">
                {formType === 'signup' ? 'Create Account' : 'Sign In'}
              </button>
            </form>
            <div className="mt-4 text-center text-sm" data-id="element-3115">
              {formType === 'signup' ? <p className="dark:text-gray-300" data-id="element-3116">
                  Already have an account?{' '}
                  <button onClick={toggleFormType} className="text-gray-800 dark:text-gray-200 underline" data-id="element-3117">
                    Sign In
                  </button>
                </p> : <>
                  <p className="dark:text-gray-300" data-id="element-3118">
                    Don't have an account?{' '}
                    <button onClick={toggleFormType} className="text-gray-800 dark:text-gray-200 underline" data-id="element-3119">
                      Sign Up
                    </button>
                  </p>
                  <p className="mt-2" data-id="element-3120">
                    <Link to="/forgot-password" className="text-gray-800 dark:text-gray-200 underline" data-id="element-3121">
                      Forgot Password?
                    </Link>
                  </p>
                </>}
            </div>
          </div>
        </div>
        {/* Account Type Comparison */}
        {formType === 'signup' && <div className="border border-gray-300 dark:border-gray-600 rounded-lg p-6 mb-6" data-id="element-3122">
            <h3 className="text-lg font-medium mb-4 dark:text-gray-200" data-id="element-3123">
              Account Types Comparison
            </h3>
            <div className="overflow-x-auto" data-id="element-3124">
              <table className="w-full" data-id="element-3125">
                <thead data-id="element-3126">
                  <tr className="border-b border-gray-200 dark:border-gray-700" data-id="element-3127">
                    <th className="text-left py-2 px-4 dark:text-gray-200" data-id="element-3128">
                      Features
                    </th>
                    <th className="text-center py-2 px-4 dark:text-gray-200" data-id="element-3129">
                      Personal
                    </th>
                    <th className="text-center py-2 px-4 dark:text-gray-200" data-id="element-3130">
                      Business
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-3131">
                  <tr className="border-b border-gray-200 dark:border-gray-700" data-id="element-3132">
                    <td className="py-2 px-4 flex items-center dark:text-gray-300" data-id="element-3133">
                      <UsersIcon className="w-4 h-4 mr-2" data-id="element-3134" />
                      Join Communities
                    </td>
                    <td className="text-center py-2 px-4 dark:text-gray-300" data-id="element-3135">
                      ✓
                    </td>
                    <td className="text-center py-2 px-4 dark:text-gray-300" data-id="element-3136">
                      ✓
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200 dark:border-gray-700" data-id="element-3137">
                    <td className="py-2 px-4 flex items-center dark:text-gray-300" data-id="element-3138">
                      <CalendarIcon className="w-4 h-4 mr-2" data-id="element-3139" />
                      Attend Events
                    </td>
                    <td className="text-center py-2 px-4 dark:text-gray-300" data-id="element-3140">
                      ✓
                    </td>
                    <td className="text-center py-2 px-4 dark:text-gray-300" data-id="element-3141">
                      ✓
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200 dark:border-gray-700" data-id="element-3142">
                    <td className="py-2 px-4 flex items-center dark:text-gray-300" data-id="element-3143">
                      <BriefcaseIcon className="w-4 h-4 mr-2" data-id="element-3144" />
                      Apply for Jobs
                    </td>
                    <td className="text-center py-2 px-4 dark:text-gray-300" data-id="element-3145">
                      ✓
                    </td>
                    <td className="text-center py-2 px-4 dark:text-gray-300" data-id="element-3146">
                      ✓
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200 dark:border-gray-700" data-id="element-3147">
                    <td className="py-2 px-4 flex items-center dark:text-gray-300" data-id="element-3148">
                      <TicketIcon className="w-4 h-4 mr-2" data-id="element-3149" />
                      Create & Sell Event Tickets
                    </td>
                    <td className="text-center py-2 px-4 dark:text-gray-300" data-id="element-3150">
                      -
                    </td>
                    <td className="text-center py-2 px-4 dark:text-gray-300" data-id="element-3151">
                      ✓
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200 dark:border-gray-700" data-id="element-3152">
                    <td className="py-2 px-4 flex items-center dark:text-gray-300" data-id="element-3153">
                      <BriefcaseIcon className="w-4 h-4 mr-2" data-id="element-3154" />
                      Post Job Listings
                    </td>
                    <td className="text-center py-2 px-4 dark:text-gray-300" data-id="element-3155">
                      -
                    </td>
                    <td className="text-center py-2 px-4 dark:text-gray-300" data-id="element-3156">
                      ✓
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200 dark:border-gray-700" data-id="element-3157">
                    <td className="py-2 px-4 flex items-center dark:text-gray-300" data-id="element-3158">
                      <BuildingIcon className="w-4 h-4 mr-2" data-id="element-3159" />
                      Business Profile
                    </td>
                    <td className="text-center py-2 px-4 dark:text-gray-300" data-id="element-3160">
                      -
                    </td>
                    <td className="text-center py-2 px-4 dark:text-gray-300" data-id="element-3161">
                      ✓
                    </td>
                  </tr>
                  <tr className="border-b border-gray-200 dark:border-gray-700" data-id="element-3162">
                    <td className="py-2 px-4 flex items-center dark:text-gray-300" data-id="element-3163">
                      <BarChartIcon className="w-4 h-4 mr-2" data-id="element-3164" />
                      Analytics Dashboard
                    </td>
                    <td className="text-center py-2 px-4 dark:text-gray-300" data-id="element-3165">
                      Basic
                    </td>
                    <td className="text-center py-2 px-4 dark:text-gray-300" data-id="element-3166">
                      Advanced
                    </td>
                  </tr>
                  <tr data-id="element-3167">
                    <td className="py-2 px-4 flex items-center dark:text-gray-300" data-id="element-3168">
                      <CreditCardIcon className="w-4 h-4 mr-2" data-id="element-3169" />
                      Payment Processing
                    </td>
                    <td className="text-center py-2 px-4 dark:text-gray-300" data-id="element-3170">
                      -
                    </td>
                    <td className="text-center py-2 px-4 dark:text-gray-300" data-id="element-3171">
                      ✓
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>}
        {/* Additional Info */}
        <div className="text-center" data-id="element-3172">
          <p className="text-sm text-gray-600 dark:text-gray-300 mb-4" data-id="element-3173">
            {accountType === 'business' && formType === 'signup' ? 'By creating a business account, you can sell tickets, list services, and connect with the JoinToday community.' : 'Join thousands of Kenyans connecting through communities, events, and shared interests.'}
          </p>
          {accountType === 'business' && formType === 'signup' && <Link to="/partner" className="text-sm flex items-center justify-center text-gray-800 dark:text-gray-200" data-id="element-3174">
              Learn more about business opportunities{' '}
              <ArrowRightIcon className="w-3 h-3 ml-1" data-id="element-3175" />
            </Link>}
        </div>
      </div>
    </div>;
};
export default Register;